import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ArrowBackLinkComponent } from './arrow-link.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
    imports: [CommonModule, RouterModule, AngularSvgIconModule],
    exports: [ArrowBackLinkComponent],
    declarations: [ArrowBackLinkComponent],
})
export class ArrowBackLinkModule { }
